import React, { useEffect } from 'react'
import { IconSeeker, SelectSeeker } from "@ui-seeker/core"
import { Box, capitalize, Typography } from "@mui/material"
import { officeModalData } from "@signals"


export default function ModalTypesSelector({ applyFilters, typesOptions, onChangeType }) {

	const icon = {
		airport: 'plane-departure',
		downtown: 'city',
		truck: 'truck',
		trainStation: 'train'
	} || 'plane-departure'

	useEffect(() => {
		applyFilters()
	}, [typesOptions])

	const options = Array.from(new Set(officeModalData.value.map(({ type }) => type))).map(type => ({
		value: type,
		label: (
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: .5 }}>
				<IconSeeker icon={icon[type]}/>
				<Typography>{capitalize(type)}</Typography>
			</Box>
		)
	}))


	return <SelectSeeker
		multiple
		label="Filter office type"
		placeholder="All types"
		value={typesOptions}
		onChange={onChangeType}
		isClearable
		options={options}
	/>
}